import React from "react";
import { useTranslation } from "react-i18next";

const socialIcons = {
  bluesky: "./img/bluesky-icon.png",
  scholargoogle: "./img/google-scholar-icon.png",
  github: "./img/github-icon.png",
  linkedin: "./img/linkedin.png",
  gmail: "./img/gmail.png"
};

const teamMembers = [
  {
    photo: "./img/team/JesusMario.JPG",
    name: "Dr. Jesús Mario Siqueiros García",
    university: "IIMAS, UNAM",
    socials: [
      { type: "bluesky", url: "https://bsky.app/profile/jmsiqueiros.bsky.social" },
      { type: "scholargoogle", url: "https://scholar.google.com/citations?user=lTdvvYAAAAAJ&hl=en" },
      { type: "gmail", url: "mailto:jmario.siqueiros@iimas.unam.mx" }
    ]
  },
  {
    photo: "./img/team/CarlosIgnacio.JPG",
    name: "Dr. Carlos Ignacio Hernández Castellanos",
    university: "IIMAS, UNAM",
    socials: [
      { type: "github", url: "https://cihdezc.github.io/" },
      { type: "gmail", url: "mailto:carlos.hernandez@iimas.unam.mx" }
    ]
  },
  {
    photo: "./img/team/Marco.JPG",
    name: "Mtro. Marco Antonio Rosas Pulido",
    university: "C3, UNAM",
    socials: [
      { type: "linkedin", url: "https://www.linkedin.com/in/marco-rosas-44252316b/" },
      { type: "gmail", url: "mailto:marco.rosas@c3.unam.mx" }
    ]
  },
  {
    photo: "./img/team/Fernanda_Perez.jpg",
    name: "Fernanda Pérez Lombardini",
    university: "FMVZ, UNAM",
    socials: [
      { type: "linkedin", url: "https://www.linkedin.com/in/fernanda-p%C3%A9rez-lombardini-611352b2/" },
      { type: "gmail", url: "mailto:ferperlom@gmail.com" }
    ]
  },
  {
    photo: "./img/team/ulises.jpg",
    name: "Ulises P. Hoil",
    university: "Investigador Independiente",
    socials: [
      { type: "github", url: "https://github.com/uligeo" },
      { type: "gmail", url: "mailto:uliseshoilca@gmail.com" }
    ]
  },
  {
    photo: "./img/team/Zinnya.jpg",
    name: "Mtra. Zinnya del Villar Islas",
    university: "Data PopAlliance",
    socials: [
      { type: "linkedin", url: "https://www.linkedin.com/in/zinnya-del-villar/" },
      { type: "gmail", url: "mailto:zdelvillar@datapopalliance.org" }
    ]
  },
  {
    photo: "./img/team/Dra_blanca.jpeg",
    name: "Dra. Blanca Hilda Vázquez Gómez",
    university: "IIMAS Yucatán, UNAM",
    socials: []
  }
];

export const Team = () => {
  const { t } = useTranslation();

  return (
    <div id="team" className="team-section">
      <div className="container">
        <div className="section-title">
          <h2>{t("team.titulo")}</h2>
          <p>{t("team.subtitulo")}</p>
        </div>
        <div className="team-cards">
          {teamMembers.map((member, index) => (
            <div key={index} className="card">
              <div className="card-inner">
                <div className="card-front">
                  <div className="card-image">
                    <img src={member.photo} alt={member.name} />
                  </div>
                  <div className="card-content">
                    <h3 className="card-name">{member.name}</h3>
                    <p className="card-role">{t(`team.rol${index + 1}`)}</p>
                    <p className="card-university">{member.university}</p>
                  </div>
                </div>
                <div className="card-back">
                  <div className="back-text">
                    {t(`team.descripcion${index + 1}`)}
                  </div>
                  {/* Línea de separación */}
                  <div className="separator" />
                  <div className="card-actions-back">
                    {member.socials.map((social, i) => (
                      <a key={i} href={social.url} target="_blank" rel="noopener noreferrer">
                        <img src={socialIcons[social.type]} alt={social.type} />
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style jsx>{`
        .team-section {
          padding: 60px 0;
          background: #f9f9f9;
          text-align: center;
        }
        .container {
          width: 90%;
          max-width: 1200px;
          margin: 0 auto;
        }
        .section-title {
          margin-bottom: 40px;
        }
        .section-title h2 {
          font-size: 32px;
          margin-bottom: 10px;
          color: #333;
        }
        .section-title p {
          color: #777;
        }
        .team-cards {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 30px;
        }
        .card {
          width: 300px;
          height: 400px;
          perspective: 1000px;
        }
        .card-inner {
          position: relative;
          width: 100%;
          height: 100%;
          transform-style: preserve-3d;
          transition: transform 0.6s;
        }
        .card:hover .card-inner {
          transform: rotateY(180deg);
        }
        .card-front,
        .card-back {
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          top: 0;
          left: 0;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }
        .card-front {
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }
        .card-image img {
          width: 100%;
          height: 200px;
          object-fit: cover;
        }
        .card-content {
          padding: 20px;
          flex: 1;
        }
        .card-name {
          margin: 0;
          font-size: 20px;
          color: #333;
          font-weight: bold;
        }
        .card-role {
          margin-top: 10px;
          color: #555;
          font-size: 16px;
        }
        .card-university {
          margin-top: 5px;
          color: #777;
          font-size: 14px;
          font-style: italic;
        }
        .card-back {
          transform: rotateY(180deg);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px;
        }
        .back-text {
          font-size: 14px;
          color: #333;
          text-align: left;
          overflow-y: auto;
          padding: 0 10px;
        }
        .separator {
          width: 80%;
          height: 1px;
          background: #ccc;
          margin: 10px auto;
        }
        .card-actions-back {
          display: flex;
          gap: 15px;
          justify-content: center;
        }
        .card-actions-back a img {
          width: 24px;
          height: 24px;
          transition: transform 0.3s ease;
        }
        .card-actions-back a:hover img {
          transform: scale(1.1);
        }
      `}</style>
    </div>
  );
};
